(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  document.documentElement.classList.add('glow-motion-ready');

  /* Reveal on scroll: [data-glow-reveal] gets .is-revealed once it enters the viewport */
  const revealObserver =
    'IntersectionObserver' in window && !designMode
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              revealObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
        )
      : null;

  const reveal = (root) => {
    root.querySelectorAll('[data-glow-reveal]:not(.is-revealed)').forEach((element) => {
      if (revealObserver && !reduceMotion.matches) {
        revealObserver.observe(element);
      } else {
        element.classList.add('is-revealed');
      }
    });
  };

  /* Pointer tilt: [data-glow-tilt] leans toward the cursor on desktop */
  const bindTilt = (root) => {
    if (!finePointer.matches || reduceMotion.matches) return;
    root.querySelectorAll('[data-glow-tilt]:not([data-glow-tilt-bound])').forEach((element) => {
      element.setAttribute('data-glow-tilt-bound', '');
      const strength = parseFloat(element.dataset.glowTilt) || 6;
      let frame = null;

      element.addEventListener('pointermove', (event) => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = null;
          const rect = element.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width;
          const y = (event.clientY - rect.top) / rect.height;
          element.style.setProperty('--tilt-x', `${((0.5 - y) * strength).toFixed(2)}deg`);
          element.style.setProperty('--tilt-y', `${((x - 0.5) * strength).toFixed(2)}deg`);
          element.style.setProperty('--glare-x', `${(x * 100).toFixed(1)}%`);
          element.style.setProperty('--glare-y', `${(y * 100).toFixed(1)}%`);
          element.classList.add('is-tilting');
        });
      });

      element.addEventListener('pointerleave', () => {
        element.classList.remove('is-tilting');
        element.style.setProperty('--tilt-x', '0deg');
        element.style.setProperty('--tilt-y', '0deg');
      });
    });
  };

  const init = (root = document) => {
    reveal(root);
    bindTilt(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
